export const SourceId = "locations";
export const ClusterMaxZoom = 14;
export const ClusterRadius = 50;
export const MapDefaultZoom = 10;
export const MapCenter = [51.4, 35.7];

export const GetClusterLayer = {
    id: "clusters",
    type: "circle",
    source: SourceId,
    paint: {
        "circle-color": [
            "step",
            ["get", "point_count"],
            "#c9ffd8",
            5,
            "#a8ffc0",
            50,
            "#87ffa8",
            100,
            "#63d682",
            500,
            "#50b56b",
        ],
        "circle-radius": [
            "step",
            ["get", "point_count"],
            20,
            5,
            25,
            50,
            30,
            100,
            35,
            500,
            40,
        ],
    },
};

export const GetClusterPointsLayer = {
    id: "clustered-point",
    type: "symbol",
    source: SourceId,
    filter: ["has", "point_count"],
    layout: {
        "text-field": ["get", "point_count"],
        "text-font": ["Vazir Regular"],
    },
};

export const UnClusteredPointId = "unclustered-point";

export const GetUnClusterPointsLayer = {
    id: UnClusteredPointId,
    type: "symbol",
    source: SourceId,
    filter: ["!", ["has", "point_count"]],
    layout: {
        "icon-image": [
            "match",
            ["get", "status"],
            0,
            "visited",
            1,
            "bonyan",
            2,
            "royan",
            3,
            "taban",
            "",
        ],
        "icon-size": 0.5,
        "icon-allow-overlap": true,
    },
};

export const MapIcons = [
    { src: "/images/pins/bonyan_pin.png", id: "bonyan", title: "پین بنیان" },
    { src: "/images/pins/royan_pin.png", id: "royan", title: "پین رویان" },
    { src: "/images/pins/taban_pin.png", id: "taban", title: "پین تابان" },
    {
        src: "/images/pins/taban_plus_pin.png",
        id: "taban_plus",
        title: "پین تابان پلاس",
    },
    {
        src: "/images/pins/visited_pin.png",
        id: "visited",
        title: "پین مشاهده شده",
    },
];
